import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api, LitSquadCraftInput, LitSquadCraftResult } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

/**
 * Executes a LitSquad accessory craft. On success, invalidates every
 * query that could show stale data: LitSquad inventory (new item just
 * appeared), DFE inventory (ingredients burned), the crafting ingredients
 * endpoint (user counts changed), and the LitSquad transfer history.
 */
export function useLitSquadCraftMutation() {
  const queryClient = useQueryClient();

  const mutation = useMutation<LitSquadCraftResult, Error, LitSquadCraftInput>({
    mutationFn: (input) => api.executeLitSquadCraft(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.litSquad.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.dfe.all });
    },
  });

  return {
    result: mutation.data ?? null,
    loading: mutation.isPending,
    error: mutation.error ? mutation.error.message : null,
    craft: (input: LitSquadCraftInput) => mutation.mutateAsync(input),
    reset: () => mutation.reset(),
  };
}
